import { goToRacingGame } from '@racings/helpers/goToRacingGame';
import { virtualSportsIds } from '@common/constants/enums/virtualSports';
import { browserHistory } from './browserHistory';

export const goToGame = ({
  gameId,
  isActive = false,
  listType = 'all',
  gameType,
  racingType,
  marketId,
  regionId,
  sportId,
  sportAlias = 'all',
  regionAlias = 'all',
  competitionId = 'all',
  routePrefix,
  isRacingEvent = false,
  betBuilder = false,
} = {}) => {
  if (virtualSportsIds.includes(sportId)) {
    browserHistory.push(`${routePrefix || '/betting/virtuals'}/${sportId}/${regionId}/${competitionId}/${gameId}`);
  } else if (isRacingEvent) {
    goToRacingGame({
      gameId,
      regionId,
      racingType,
      competitionId,
    });
  } else {
    const queryParts = [];
    if (marketId) queryParts.push(`marketId=${marketId}`);
    if (betBuilder) queryParts.push('betBuilder=1');
    const query = queryParts.length ? `?${queryParts.join('&')}` : '';
    const path = isActive || listType === 'outright'
      ? `${routePrefix || '/betting'}/${gameType}/${listType}/${sportAlias}/${regionAlias || 'all'}/${competitionId}`
      : `${routePrefix || '/betting'}/${gameType}/${listType}/${sportAlias}/${regionAlias || 'all'}/${competitionId}/${gameId}`;

    const gameDetailsPath = `${path}${query}`;

    browserHistory.push(gameDetailsPath);
  }
};
